<template>
  <div class="AverbacaoEProcedimento">
    <div class="row mt-2">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-sm btn-gray mr-2"
                @click="showModalWizard = true">
          <IconSvg icon="add"
                   class="icon--xxs mb-1 icons--white" />
          Adicionar procedimento
        </button>
        <button class="btn btn-sm btn-primary"
                @click="showForm('LEGADO')">
          <IconSvg icon="add"
                   class="icon--xxs mb-1 icons--white" />
          Adicionar averbação
        </button>
      </div>
    </div>
    <b-modal v-if="showModalWizard"
             :id="`modalAverbacaoEProcedimento`"
             :ref="`modalAverbacaoEProcedimento`"
             :hide-footer="true"
             class="AverbacaoEProcedimento_modal"
             header-class="AverbacaoEProcedimento_modal_header"
             body-class="AverbacaoEProcedimento_modal_body"
             content-class="AverbacaoEProcedimento_modal_content"
             title="Adicionar Procedimento"
             no-close-on-backdrop
             no-close-on-esc
             centered
             size="md"
             visible
             @close="hideModalWizard(true)">
      <div v-if="passo === 1"
           class="row">
        <div class="col-12">
          <label for="acoes"
                 class="label">Escolha o procedimento que deseja fazer</label>
        </div>
        <div class="col-12 mt-2">
          <select id="acoes"
                  v-model="form.acao"
                  class="custom-select custom-select-sm"
                  name="acoes">
            <option :value="null"
                    disabled>
              Selecione
            </option>
            <option v-for="(opcao, index) in acoesFiltered"
                    :key="index"
                    :value="opcao.value">
              {{ opcao.label }}
            </option>
          </select>
        </div>
        <div class="col-12 d-flex justify-content-end mt-3">
          <button class="btn btn-sm btn-primary px-3"
                  :disabled="!form.acao"
                  @click="passo++">
            Continuar
          </button>
        </div>
      </div>
      <div v-else-if="passo === 2"
           class="row justify-content-center">
        <div class="col-8">
          <label for=""
                 class="label">Qual a origem?</label>
        </div>
        <div class="col-8 d-flex justify-content-between mt-2">
          <b-form-radio
            v-for="(origem, index) in origensFiltered"
            :key="index"
            v-model="form.origem"
            checked
            :value="origem.value"
            :disabled="origem.disabled">
            {{ origem.label }}
          </b-form-radio>
        </div>
        <div class="col-12 d-flex justify-content-end mt-3">
          <button class="btn btn-sm btn-primary px-3"
                  :disabled="!form.origem"
                  @click="verifyNextStep()">
            Continuar
          </button>
        </div>
      </div>
      <div v-else-if="passo === 3"
           class="row justify-content-center">
        <div class="col-12">
          <label for=""
                 class="label">Escolha o motivo do procedimento</label>
        </div>
        <div class="col-12 d-flex justify-content-between mt-2">
          <select id="motivo"
                  v-model="form.motivo"
                  class="custom-select custom-select-sm"
                  name="motivo">
            <option :value="null"
                    disabled>
              Selecione
            </option>
            <option v-for="(motivo, index) in tiposAlteracao"
                    :key="index"
                    :value="motivo.value"
                    :disabled="!motivo.origens.includes(form.origem)">
              {{ motivo.label }}
            </option>
          </select>
        </div>
        <div class="col-12 d-flex justify-content-end mt-3">
          <button class="btn btn-sm btn-primary px-3"
                  :disabled="!form.motivo"
                  @click="showForm('NOVA')">
            Continuar
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal v-if="showModalForm"
             v-show="showModalFormOnDestroy"
             :id="`modalAverbacaoEProcedimento`"
             :ref="`modalAverbacaoEProcedimento`"
             :hide-footer="true"
             class="AverbacaoEProcedimento_modal"
             header-class="AverbacaoEProcedimento_modal_header"
             body-class="AverbacaoEProcedimento_modal_body"
             content-class="AverbacaoEProcedimento_modal_content"
             no-close-on-backdrop
             no-close-on-esc
             centered
             size="xl"
             visible>
      <template slot="modal-header">
        <div v-if="tipo === 'LEGADO'">
          <b class="ml-2">Adicionar Averbação</b>
        </div>
        <div v-else>
          <b class="ml-2">{{ getLabelAcao(form.acao) }} - {{ form.motivo ? getLabelMotivo(form.motivo) : getLabelOrigem(form.origem) }}</b>
        </div>
      </template>
      <div class="row">
        <div class="col-12">
          <FormAverbacao v-if="tipo === 'LEGADO'"
                         ref="FormAverbacao"
                         :tipo-registro="propTipoRegistro"
                         :registro-id="propRegistroId"
                         :prop-averbacao="averb"
                         :prop-transporte="propTransporte"
                         @hideModal="hideModalForm(true, gerarOS)" />
        </div>
        <div class="col-12">
          <FormProcedimento v-if="tipo === 'NOVA'"
                            :prop-form="form"
                            :registro-id="propRegistroId"
                            @hideForm="hideModalForm"
                            @changed="changed"
                            @salvarProcedimento="salvarProcedimento"
                            @atualizarProcedimento="atualizarProcedimento" />
        </div>
      </div>
    </b-modal>

    <!-- Listagem procedimentos -->
    <div
      @mouseleave="validarAlteracao">
      <collapse-default id="procedimentos"
                        :collapse-visible="!!procedimentos.length"
                        :condition="!!procedimentos.length">
        <template v-slot:header>
          Procedimentos {{ !procedimentos.length ? '- Nenhum procedimento cadastrado' : '' }}
        </template>
        <template v-slot:content>
          <div class="row">
            <div class="col-12">
              <BoxProcedimento v-for="(proc, index) in procedimentos"
                               :key="index"
                               :prop-procedimento="proc"
                               class="mt-3"
                               @editarProcedimento="editarProcedimento"
                               @excluirProcedimento="excluirProcedimento" />
            </div>
          </div>
        </template>
      </collapse-default>


      <!-- Listagem averbações -->
      <collapse-default id="averbacoes"
                        :collapse-visible="!!averbacoes.length"
                        :condition="!!averbacoes.length">
        <template v-slot:header>
          Averbações {{ !averbacoes.length ? '- Nenhuma averbação cadastrada' : '' }}
        </template>
        <template v-slot:content>
          <div class="row">
            <div class="col-12">
              <BoxAverbacoes v-for="(averbacao, index) in averbacoes"
                             :key="index"
                             :prop-averbacao="averbacao"
                             :prop-transporte="propTransporte"
                             :prop-index="index"
                             :prop-failupdate="failValidate(averbacao.documento_id)"
                             :prop-change="editAverbacoes.length"
                             class="mt-2"
                             @multiplaEdicaoAverbacao="multipleEditionAverbacao"
                             @editarAverbacao="editarAverbacao"
                             @destroyAverbacao="destroyAverbacao"
                             @imprimirAverbacao="imprimirAverbacao" />
            </div>
          </div>
          <div v-show="editAverbacoes.length > 0"
               class="averbacoes-buttons">
            <div class="d-inline-block">
              <button class="btn btn-sm btn-dark"
                      @click="cancelMultipleEditionAverbacao">
                Cancelar
              </button>
            </div>

            <div class="d-inline-block ml-2">
              <button id="btn-submit-registro"
                      class="btn btn-sm btn-primary"
                      type="button"
                      @click="validateSignAverbacao">
                Salvar
              </button>
            </div>
          </div>
        </template>
      </collapse-default>
    </div>

    <b-modal v-if="showModalAverbacao"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             :hide-header="true"
             :hide-footer="true">
      <AverbacaoSV :registro-id="propRegistroId"
                   :prop-show-text="false"
                   :prop-texto-procedimento="textoProcedimento"
                   :prop-transporte="propTransporte"
                   @hideModal="hideModalAverbacao(gerarOS)" />
    </b-modal>

    <FormAverbacao v-show="false"
                   ref="FormAverbacao"
                   :tipo-registro="propTipoRegistro"
                   :registro-id="propRegistroId"
                   @hideModal="hideModalForm" />

    <b-modal v-if="showModalOrdemServico"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             :hide-header="true"
             :hide-footer="true"
             body-class="p-0">
      <OrdemServico class="m-0 p-0"
                    prop-procedimento
                    :prop-registro-id="propRegistroId"
                    :prop-tipo-registro="tiposRegistros[propTipoRegistro]"
                    :prop-registro="propRegistro"
                    :prop-data="propData"
                    :prop-acao="procedimento.acao"
                    :prop-procedimentos="true"
                    @getOS="getOS"
                    @onTabImpressao="tabImpressao"
                    @imprimir="imprimir"
                    @voltar="hideModalOS()" />
    </b-modal>

    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @onSelectCertificado="onSelectCertificado" />
    </b-modal>
  </div>
</template>

<script>
  // components
  import FormAverbacao from '@/components/SofiaRei/Resumo/FormAverbacao.vue'
  import FormProcedimento from '@/components/SofiaRei/Casamento/FormProcedimento.vue'
  import AverbacaoSV from '@/components/SofiaRei/Nascimento/SegundaVia/AverbacaoSV'
  import BoxAverbacoes from '@/components/SofiaRei/Resumo/BoxAverbacoes.vue'
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"
  import BoxProcedimento from '@/components/SofiaRei/Casamento/BoxProcedimento.vue'
  import GridCertificados from '@/components/GridCertificados'

  // views
  import OrdemServico from '@/components/SofiaRei/Resumo/OrdensServico/OrdemServico.vue'


  // services
  import AverbacoesService from "@/services/Registros/AverbacoesService"
  import ProcedimentoService from "@/services/ProcedimentoService"
  import BryService from "@/services/Assinaturas/BryService"

  // filters
  import { filterMaskedNumber } from '@/filters/filters'

  // outros
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import DocumentosService from "@/services/Documentos"

  export default {
    name: 'AverbacaoEProcedimento',
    components: {
      FormAverbacao,
      FormProcedimento,
      AverbacaoSV,
      BoxAverbacoes,
      BoxProcedimento,
      CollapseDefault,
      OrdemServico,
      GridCertificados
    },
    props: {
      propRegistroId: { type: Number, default: null },
      propTipoRegistro: { type: String, default: null },
      propRegistro: { type: Object, default: null },
      propRegimeBens: { type: String, default: null },
      propTransporte: { type: Object, default: null },
      propData: { type: Object, default: null}
    },
    data () {
      return {
        procedimentos: [],
        averbacoes: [],
        editAverbacoes: [],
        alterAverbacoes: [],
        validar: true,
        certificados: [],
        certificadoSelecionado: null,
        certificateData: null,
        failUpdate: [],
        livroDeRegistro: null,
        showModalWizard: false,
        showModalForm: false,
        showModalAverbacao: false,
        showModalOrdemServico: false,
        tipo: null,
        showModalFormOnDestroy: true,
        form: {
          tipo: null,
          acao: null,
          motivo: null,
          forma: null,
          procedimentoArquivo: [],
          origem: null,
          data_escritura: null,
          data_sentenca: null,
          data_transito_julgado: null,
          data_mandado: null,
          num_processo: null,
          num_livro: null,
          num_folha: null,
          uf: null,
          cidade: null,
          cartorio: null,
          comarca: null,
          vara: null,
          juiz: null,
          nome_conjuge_1: null,
          nome_conjuge_2: null,
          data_averbacao: null,
          isento: false,
          gerar_protocolo: false,
          gerar_os: false,
          registro_id: this.propRegistroId,
          cartorio_id: this.cartorioId,
          protocolo_id: null,
          ordem_servico_id: null,
          deleteds: [],
          texto_procedimento: null,
        },
        passo: 1,
        acoes: [
          { label: 'Alteração de Estado Civil', value: 'ALTERACAO_ESTADO_CIVIL', registros: ['C', 'CR'] },
          { label: 'Inteiro Teor', value: 'INTEIRO_TEOR', registros: ['C', 'CR', 'O', 'NT', 'N']}
        ],
        tiposAlteracao: [
          { label: 'Divórcio', value: 'DIVORCIO', origens: ['ESCRITURA', 'MANDADO'] },
          { label: 'Separação', value: 'SEPARACAO', origens: ['ESCRITURA', 'MANDADO'] },
          { label: 'Reconciliação', value: 'RECONCILIACAO', origens: ['ESCRITURA', 'MANDADO'] },
          { label: 'Desquite', value: 'DESQUITE', origens: ['MANDADO'] },
          { label: 'Anulação', value: 'ANULACAO', origens: ['MANDADO'] },
        ],
        origens: [
          { label: 'Escritura', value: 'ESCRITURA', acoes: ['ALTERACAO_ESTADO_CIVIL']},
          { label: 'Mandado', value: 'MANDADO', acoes: ['ALTERACAO_ESTADO_CIVIL']},
          { label: 'Digitado', value: 'DIGITADO', acoes: ['INTEIRO_TEOR']},
          { label: 'Cópia reprográfica', value: 'COPIA_REPROGRAFICA', acoes: ['INTEIRO_TEOR'], disabled: true}
        ],
        averb: null,
        gerarOS: false,
        procedimento: null,
        registrosAnteriores: [],
        textoProcedimento: null,
        ordemServico: null,
        tiposRegistros: {
          'C': 'casamento',
          'CR': 'casamento',
          'NT': 'obito',
          'O': 'obito',
          'N': 'nascimento'
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorio: 'auth/getCartorioObj',
        user: 'auth/getUser'
      }),
      acoesFiltered () {
        return this.acoes.filter(acao => acao.registros.includes(this.propTipoRegistro))
      },
      origensFiltered () {
        return this.origens.filter(origem => origem.acoes.includes(this.form.acao))
      }
    },
    watch: {
      showModalWizard () {
        // Pre definindo como origem Digitado enquanto origem Copia Reprografica nao eh liberada.
        !this.form.origem && this.showModalWizard == true ? this.form.origem = 'DIGITADO' : null
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      async init () {
        await Promise.all([
          this.getAverbacoes(),
          this.getProcedimentos(),
          this.getRegistrosAnteriores()]
        )

        const livroDeRegistro = await DocumentosService.getLivroDeRegistro(this.propRegistroId)

        if (livroDeRegistro) {
          this.livroDeRegistro = livroDeRegistro
        }
      },
      async getAverbacoes () {
        try {
          loader({ active: true, text: 'Buscando averbações...'})

          const averbacoes = await AverbacoesService.getAverbacaoByRegistroId(this.propRegistroId)
          this.averbacoes = averbacoes
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ''})
        }
      },
      async showForm (tipo) {
        if (!this.registrosAnteriores.length && this.form.acao !== 'INTEIRO_TEOR') {
          const res = await displayMessage('question', 'Alerta!', 'Não existem registros anteriores neste registro. Se continuar nenhuma tarefa de comunicação será criada.')

          if (!res.value) {
            this.hideModalWizard(true)
            return
          }
        }

        if (this.form.acao === 'ALTERACAO_ESTADO_CIVIL') {
          if (this.propRegistro.pessoas && this.propRegistro.pessoas.length) {
            this.form.nome_conjuge_1 = this.propRegistro.pessoas[0].nome_antigo || this.propRegistro.pessoas[0].nome
            this.form.nome_conjuge_2 = this.propRegistro.pessoas[1].nome_antigo || this.propRegistro.pessoas[1].nome
            if (this.propRegistro.pessoas[0].sexo !== this.propRegistro.pessoas[1].sexo && this.propRegistro.pessoas[0].sexo !== 'I' && this.propRegistro.pessoas[1].sexo !== 'I') {
              this.form.nome_conjuge_1 = this.propRegistro.pessoas.find(pessoa => pessoa.sexo === 'M').nome_antigo || this.propRegistro.pessoas.find(pessoa => pessoa.sexo === 'M').nome
              this.form.nome_conjuge_2 = this.propRegistro.pessoas.find(pessoa => pessoa.sexo === 'F').nome_antigo || this.propRegistro.pessoas.find(pessoa => pessoa.sexo === 'F').nome
            }
          }
        }

        this.tipo = tipo
        this.showModalForm = true
        this.hideModalWizard()
      },
      hideModalWizard (reset) {
        this.showModalWizard = false
        this.passo = 1

        if (reset) {
          this.cleanForm()
        }
      },
      changed (form) {
        this.form = form
      },
      async salvarProcedimento (form) {
        const obj = { ...form }

        try {
          loader({ active: true, text: 'Cadastrando procedimento...'})

          this.gerarOS = form.gerar_os
          this.gerar_protocolo = form.gerar_protocolo

          if (obj.cpf_requerente) obj.cpf_requerente = filterMaskedNumber(obj.cpf_requerente)

          const requerente = {
            nome: obj.nome_requerente,
            cpf: obj.cpf_requerente
          }

          const res = await ProcedimentoService.cadastrarProcedimento(obj)

          if (res) {
            this.procedimento = res

            this.$store.dispatch('procedimento/updateProcedimento', res)
            this.$store.dispatch('procedimento/updateRequerente', requerente)

            if (this.form.acao === 'INTEIRO_TEOR') {
              this.$store.dispatch('procedimento/updateInteiroTeor', true)
            } else {
              this.$store.dispatch('procedimento/updateAlteracaoEstadoCivil', true)
            }

            if (this.gerarOS) {
              this.$store.dispatch('procedimento/updateZerarCustas', form.isento)
              this.showModalForm = false
              this.showModalOrdemServico = true
            } else {
              if (this.form.acao !== 'INTEIRO_TEOR') {
                this.getTextoAverbacao(obj)

                this.hideModalForm()

                this.showModalAverbacao = true
              } else {
                this.hideModalForm()
              }
            }
          }

          await this.init()
        } catch (error) {
          this.$store.dispatch('procedimento/updateRequerente', {
            nome: null,
            cpf: null
          })

          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ active: false, text: ''})
        }
      },
      async atualizarProcedimento (form) {
        const obj = { ...form }

        try {
          loader({ active: true, text: 'Atualizando procedimento...'})

          this.gerarOS = form.gerar_os
          this.gerar_protocolo = form.gerar_protocolo

          if (obj.cpf_requerente) obj.cpf_requerente = filterMaskedNumber(obj.cpf_requerente)

          const res = await ProcedimentoService.atualizarProcedimento(obj, obj.procedimento_id)

          if (res) {
            this.hideModalForm()
            this.procedimento = res
          }

          await this.init()
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ active: false, text: ''})
        }
      },
      async getProcedimentos () {
        try {
          loader({ active: true, text: 'Buscando procedimentos...'})

          const res = await ProcedimentoService.getProcedimentos({cartorio_id: this.cartorioId, registro_id: this.propRegistroId})

          this.procedimentos = res
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ active: false, text: ''})
        }
      },
      async excluirProcedimento (procedimentoId) {
        try {
          loader({active: true, text: 'Excluindo...'})

          await ProcedimentoService.excluirProcedimento(procedimentoId)

          const index = this.procedimentos.find(procedimento => procedimento.procedimento_id)

          if (index >= 0) {
            this.procedimentos.splice(index, 1)
          }

          this.$toast.success('Procedimento excluido com sucesso!', {
            position: 'top-right',
            duration: 5000
          })

          await this.init()
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ''})
        }
      },
      async editarAverbacao (averb) {
        await this.cancelMultipleEditionAverbacao()

        this.averb = averb
        this.tipo = 'LEGADO'
        this.showModalForm = true
      },
      async destroyAverbacao (documento_id) {
        await this.cancelMultipleEditionAverbacao()

        this.showModalForm = true
        this.showModalFormOnDestroy = false
        this.$nextTick(
          await function () {
            this.$refs.FormAverbacao.destroy(documento_id)
          }.bind(this)
        )
      },
      async imprimirAverbacao (averb) {
        await this.cancelMultipleEditionAverbacao()

        this.showModalForm = true
        this.$nextTick(
          await function () {
            this.$refs.FormAverbacao.imprimirAverbacao(averb)
          }.bind(this)
        )
        this.showModalForm = false
      },
      multipleEditionAverbacao (averb) {
        this.validar = true
        this.editAverbacoes.push(averb)
      },
      async cancelMultipleEditionAverbacao () {
        this.validar = false
        await this.getAverbacoes()
        this.alterAverbacoes = []
        this.certificadoSelecionado = null
        this.certificateData = null
        this.editAverbacoes = []
        this.failUpdate = []
      },
      async saveMultiplaEdicaoAverbacao () {
        let averbacaoData = ''
        let confirmed = 0
        let fails = []
        let status = []
        this.failUpdate = []

        for (const averbacao of this.alterAverbacoes) {
          if (this.livroDeRegistro && averbacao.averb_impressa_livro) {
            averbacao && averbacao.origem == "SOFIA_GED" ? status.push(await this.atualizaAverbacaoGED(true, averbacao)) : status.push(await this.atualizaAverbacao(true, averbacao))
          } else  {
            averbacao && averbacao.origem == "SOFIA_GED" ? status.push(await this.atualizaAverbacaoGED(false, averbacao)) : status.push(await this.atualizaAverbacao(false, averbacao))      
          }
        }

        for (const res of status) {
          if (res.message) {
            fails.push(res)
          } else {
            confirmed += 1
          }
        }

        for (const fail of fails) {
          averbacaoData += "<b>data: " + moment(fail.data, "YYYY/MM/DD").format("DD/MM/YYYY") + "</b> - " + fail.message + "<br><br>"
          this.failUpdate.push(fail.id)
        }

        const textSuccess = confirmed ? "Atualizadas com sucesso: " + "<b>" + confirmed + "</b><br><br>" : ''
        const textFail = fails && averbacaoData ? "Com erro ao atualizar: " + "<b>" + fails.length + "</b><br><br>" : ''
        const textDescricao = fails && averbacaoData ? "<b>Averbações com erro:</b><br>" : ''
        const textAvervacaoData = fails && averbacaoData ? averbacaoData : ''

        const text =  textSuccess + textFail + textDescricao + textAvervacaoData

        // Mensagem de sucesso
        objSwal.success.title = "Averbações - resultado:"
        objSwal.success.text = ''
        objSwal.success.html = text

        await Swal.fire(objSwal.success)

        this.editAverbacoes = []
        this.alterAverbacoes = []
        this.certificadoSelecionado = null
        this.certificateData = null
        await this.getAverbacoes()
      },
      failValidate (id) {
        let res = false
        for (const errorId of this.failUpdate) {
          if (errorId === id) {
            res = true
          }
        }
        return res
      },
      async validateSignAverbacao () {
        //Elimina duplicados
        this.alterAverbacoes = [...new Set(this.editAverbacoes)]
        this.validar = false
        let needSign = false

        //Verifica a necessidade de assinar uma averbação o certificado
        for (const averbacao of this.alterAverbacoes) {
          if (this.livroDeRegistro && averbacao.averb_impressa_livro) {
            needSign = true
          }
        }

        if (needSign) {
          await this.obterCertificados()
        } else {
          await this.saveMultiplaEdicaoAverbacao()
        }
      },
      async obterCertificados () {
        loader({ text: 'Validando extensão...', active: true })
        if (!BryService.isExtensionInstalled()) {

          loader({ text: '', active: false })

          objSwal.info.title = 'Extensão não instalada'
          objSwal.info.text = 'A extensão para assinatura digital não está instalada no seu navegador. Deseja instalar agora?'
          objSwal.info.html = ''
          objSwal.info.confirmButtonText = 'Instalar'
          objSwal.info.showCancelButton = true
          objSwal.info.cancelButtonText = 'Não'

          return Swal.fire(objSwal.info).then(({ value }) => {
            if (value) {
              try {
                BryService.getExtension()
              } catch (e) {
                this.onLoginError('Erro', e.message)
              }
            }
          })
        }

        const certificados = await BryService.getCertificates()

        // Retornamos apenas certificados do tipo 'A3'
        this.certificados = certificados.filter(certificate => {
          return certificate.certificateType === 'A3'
        })

        loader({ text: '', active: false })

        if (this.certificados.length === 0) {
          this.cancelMultipleEditionAverbacao ()
          loader({ text: '', active: false })

          objSwal.error.title = 'Erro'
          objSwal.error.text = 'Não foi possível selecionar o certificado. Nenhum certificado foi encontrado'
          objSwal.error.html = ''
          return Swal.fire(objSwal.error)
        }

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()

        } else {
          this.certificadoSelecionado = this.certificados[0]
        }

        if (this.certificadoSelecionado) {
          await this.saveMultiplaEdicaoAverbacao()
        }
      },
      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado
        // Fechando modal
        this.$refs.modalCertificados.hide()
        // Anulando certificados obtidos
        this.certificados = null

        if (this.certificadoSelecionado) {
          this.saveMultiplaEdicaoAverbacao()
        }
      },
      async atualizaAverbacao (realizarAssinatura = true, averbacao) {
        let updated = false
        let fails = {}
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })
        try {
          if (averbacao.data_averbacao) averbacao.data_averbacao = moment(averbacao.data_averbacao, 'YYYY-MM-DD').format('YYYY-MM-DD')
          if (averbacao.data_importacao) averbacao.data_importacao = moment(averbacao.data_importacao, 'YYYY-MM-DD').format('YYYY-MM-DD')

          updated = await AverbacoesService.atualizarAverbacao(averbacao.documento_id, averbacao)

          if (updated.data) {
            const response = updated.data
            try {
              // Realiza a assinatura
              if (realizarAssinatura && response.documentoLivroDeRegistro) {
                await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
              }

              return updated
            } catch (e) {
              const message = getErrors(e)
              fails = {
                data: averbacao.data_averbacao,
                error: "Não foi possível realizar a assinatura digital, verifique o seu certificado digital e tente novamente " + message.message,
                id: averbacao.documento_id
              }
              return fails
            }
          }
        } catch (e) {
          const error = getErrors(e)
          fails = {
            data: averbacao.data_averbacao,
            message: "Erro ao gravar a alteração " + error.message,
            id: averbacao.documento_id
          }
          return fails
        } finally {
          NProgress.done()
          loader({ text: '', active: false })
        }
      },
      async assinaturaAverbacao (documentoLivroDeRegistro) {
        try {
          // Guarda o certificateData para quando assinarmos o Livro de Registro.
          this.certificateData = this.certificadoSelecionado.certificateData

          // Inicia a assinatura
          const iniciaAssinatura = await BryService.startSigning(this.certificateData, documentoLivroDeRegistro.documento_id)

          // Trata o objeto da assinatura
          const assinaturasObj = iniciaAssinatura.assinaturasInicializadas.map(({ nonce, messageDigest }) => {
            return BryService.prepareContentForSignature(messageDigest, nonce)
          })

          const { certId } = this.certificadoSelecionado

          // Digita a senha do certificado
          const { assinaturas } = await BryService.signBase64Content(certId, assinaturasObj)

          // Finaliza a assinatura
          await BryService.endSigning(iniciaAssinatura.nonce, assinaturas)
        } catch (e) {
          /* carregando dados */
          await this.init()

          console.error(e)
          throw "Erro ao assinar"
        }
      },
      validarAlteracao () {
        if (this.editAverbacoes.length > 0 && this.validar) {
          objSwal.question.title = 'Averbações foram alteradas'
          objSwal.question.text = 'Deseja salvar estas alterações?'
          objSwal.question.cancelButtonText = "Não"
          objSwal.question.confirmButtonText = "Sim"
          return Swal.fire(objSwal.question).then(res => {
            if (res.value) {
              this.validateSignAverbacao()
            } else {
              this.validar = false
            }
          })
        }
      },
      getLabelMotivo (motivo) {
        const tipoAlteracao = this.tiposAlteracao.find(tipo => tipo.value === motivo)

        if (tipoAlteracao) {
          return tipoAlteracao.label
        }
      },
      getLabelAcao (acao) {
        const tipoAcao = this.acoes.find(action => action.value === acao)

        if (tipoAcao) {
          return tipoAcao.label
        }
      },
      getLabelOrigem (origem) {
        const origin = this.origens.find(origin => origin.value === origem)

        if (origin) {
          return origin.label
        }
      },
      novoProcedimento () {
        this.tipo = 'NOVO'
        this.showModalWizard = true
      },
      hideModalForm (averbacao) {
        if (averbacao) {
          this.getAverbacoes()
          this.averb = null
        }

        this.cleanForm()

        this.showModalForm = false
        this.showModalFormOnDestroy = true
      },
      editarProcedimento (procedimento) {
        this.form = {
          ...procedimento
        }

        this.tipo = 'NOVA'

        this.showModalForm = true
      },
      hideModalAverbacao () {
        this.showModalAverbacao = false

        this.getAverbacoes()
      },
      getRegistrosAnteriores () {
        if (this.propRegistro.pessoas) {
          this.propRegistro.pessoas.forEach(pessoa => {
            this.registrosAnteriores = [...this.registrosAnteriores, ...pessoa.registrosAnteriores]
          })
        } else if (this.propRegistro.anteriores) {
          this.registrosAnteriores = [...this.propRegistro.anteriores]
        }

      },
      getTextoAverbacao (dados) {
        const { origem, motivo, vara, comarca, num_livro, num_folha, data_escritura, juiz, data_mandado, cartorio, num_processo, data_sentenca, data_transito_julgado, cidade } = dados
        const qtd = this.averbacoes.length
        let text = qtd < 9 ? `(AV/0${qtd + 1})` : `(AV/${qtd + 1})`

        if (origem === 'MANDADO') {
          text += ` ${this.getLabelMotivo(motivo).toUpperCase()}: Em cumprimento`
          text += ` ao mandado judicial expedido pelo MM Juiz da ${vara}`
          text += this.cartorio.comarca === comarca ? ' desta Comarca' : ''
          text += this.cartorio.comarca !== comarca ? ` da Comarca de ${comarca}` : ''
          text += `, ${juiz}, em ${moment(data_mandado).format('DD/MM/YYYY')}, por`
          text += ` sentença extraída dos autos nº ${num_processo}, datada de ${moment(data_sentenca).format('DD/MM/YYYY')}`
          text += `, transitou em julgado aos ${moment(data_transito_julgado).format('DD/MM/YYYY')}, foi homologado`
          text += ` ${this.getTextMotivo(motivo)} ${this.getLabelMotivo(motivo).toUpperCase()}. ${this.cartorio.endereco.cidade}`
          text += `, ${moment().format('DD/MM/YYYY')}, ${this.user.nome} - ${this.user.cargo}.`
        } else {
          text += ` ${this.getLabelMotivo(motivo).toUpperCase()}: À vista de Escritura Pública, lavrada pelo ${cartorio}`
          text += this.cartorio.endereco.cidade === cidade ? ' desta Comarca' : ''
          text += this.cartorio.endereco.cidade !== cidade ? ` da Comarca de ${cidade}` : ''
          text += `, no Livro ${num_livro}, fls. ${num_folha}, em data de ${moment(data_escritura).format('DD/MM/YYYY')}`
          text += `, faço a presente averbação nos termos da lei nº 11.441/2007`
          text += `,  para constar o ${this.getLabelMotivo(motivo).toUpperCase()} do casal, assinando ${this.getAssinantes(dados)};`
          text += ` ${this.tratarRegimeBens()}. ${this.cartorio.endereco.cidade}`
          text += `, ${moment().format('DD/MM/YYYY')}, ${this.user.nome} - ${this.user.cargo}.`
        }

        this.textoProcedimento = text
      },
      getAssinantes (dados) {
        const { pessoas } = this.propRegistro
        const {nome_conjuge_1, nome_conjuge_2} = dados
        let text = ''


        let pessoa_1 = pessoas.find(pessoa => pessoa.nome === nome_conjuge_1 || pessoa.nome_antigo === nome_conjuge_1)
        let pessoa_2 = pessoas.find(pessoa => pessoa.nome === nome_conjuge_2 || pessoa.nome_antigo === nome_conjuge_2)

        if (!pessoa_1) {
          pessoa_1 = pessoas.find(pessoa => {
            const { nome_antigo } = pessoa

            const primeiroNomeDados = nome_conjuge_1.split(' ')[0]
            const primeiroNomeRegistro = nome_antigo.split(' ')[0]

            if (primeiroNomeDados === primeiroNomeRegistro) {
              return pessoa
            }
          })
        }

        if (pessoa_1 && pessoa_1.sexo && pessoa_1.sexo === 'F') {
          text += nome_conjuge_1 ? `a mulher o nome de ${nome_conjuge_1.toUpperCase().trim()}` : ''
        } else if (pessoa_1 && pessoa_1.sexo && pessoa_1.sexo === 'M') {
          text += nome_conjuge_1 ? `o homem o nome de ${nome_conjuge_1.toUpperCase().trim()}` : ''
        } else {
          text += nome_conjuge_1 ? `o primeiro cônjuge o nome de ${nome_conjuge_1.toUpperCase().trim()}` : ''
        }

        if (!pessoa_2) {
          pessoa_2 = pessoas.find(pessoa => {
            const { nome_antigo } = pessoa

            const primeiroNomeDados = nome_conjuge_2.split(' ')[0]
            const primeiroNomeRegistro = nome_antigo.split(' ')[0]

            if (primeiroNomeDados === primeiroNomeRegistro) {
              return pessoa
            }
          })
        }

        text += pessoa_1 && pessoa_2 ? ' e ' : ''

        if (pessoa_2 && pessoa_2.sexo && pessoa_2.sexo === 'F') {
          text +=  nome_conjuge_2 ? `a mulher o nome de ${nome_conjuge_2.toUpperCase().trim()}` : ''
        } else if (pessoa_2 && pessoa_2.sexo && pessoa_2.sexo === 'M') {
          text += nome_conjuge_2 ? `o homem o nome de ${nome_conjuge_2.toUpperCase().trim()}` : ''
        } else {
          text += nome_conjuge_2 ? `o segundo cônjuge o nome de ${nome_conjuge_2.toUpperCase().trim()}` : ''
        }

        return text
      },
      tratarRegimeBens () {
        switch (this.propRegimeBens) {
        case 'COMUNHAO_PARCIAL':
        case 'COMUNHAO_UNIVERSAL':
        case 'PARTICIPACAO_FINAL_AQUESTOS':
          return 'e que os mesmos possuem bens a partilhar'
        case 'SEPARACAO_BENS':
        case 'SEPARACAO_LEGAL_BENS':
          return 'e que os mesmos não possuem bens a partilhar'
        default:
          return ''
        }
      },
      getTextMotivo (motivo) {
        switch (motivo) {
        case 'DIVORCIO':
        case 'DESQUITE':

          return 'o'

        default:
          return 'a'
        }
      },
      verifyNextStep () {
        if (this.form.acao === 'INTEIRO_TEOR') {
          this.showForm('NOVA')
        } else {
          this.passo++
        }
      },
      getOS (os) {
        this.procedimento.ordem_servico_id = os.ordem_servico_id

        this.ordemServico = os

        this.showModalOrdemServico = false

        if (this.form.acao !== 'INTEIRO_TEOR') this.showModalAverbacao = true

        if (!this.gerar_protocolo) {
          this.atualizarProcedimento(this.procedimento)
        }
      },
      hideModalOS () {
        this.showModalOrdemServico = false
        this.cleanForm()
      },
      cleanForm () {
        this.form = {
          tipo: null,
          forma: null,
          procedimentoArquivo: [],
          acao: null,
          motivo: null,
          origem: null,
          data_escritura: null,
          data_sentenca: null,
          data_transito_julgado: null,
          data_mandado: null,
          num_processo: null,
          num_livro: null,
          num_folha: null,
          uf: null,
          cidade: null,
          cartorio: null,
          comarca: null,
          vara: null,
          juiz: null,
          nome_conjuge_1: null,
          nome_conjuge_2: null,
          data_averbacao: null,
          isento: false,
          gerar_protocolo: false,
          gerar_os: false,
          registro_id: this.propRegistroId,
          cartorio_id: this.cartorioId,
          nome_requerente: null,
          cpf_requerente: null,
          ordem_servico_id: null,
          protocolo_id: null,
          deleteds: []
        }
      },
      imprimir (os) {
        this.$emit('imprimir', os)
      },
      tabImpressao () {
        this.$emit('onTabImpressao')
      },

      async atualizaAverbacaoGED (realizarAssinatura = true, averbacao) {
        let updated = false
        let fails = {}
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })
        try {
          if (averbacao.data_averbacao) averbacao.data_averbacao = moment(averbacao.data_averbacao, 'YYYY-MM-DD').format('YYYY-MM-DD')
          if (averbacao.data_importacao) averbacao.data_importacao = moment(averbacao.data_importacao, 'YYYY-MM-DD').format('YYYY-MM-DD')

          updated = await AverbacoesService.atualizarAverbacaoGED(averbacao)

          if (updated.data) {
            const response = updated.data
            try {
              // Realiza a assinatura
              if (realizarAssinatura && response.documentoLivroDeRegistro) {
                await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
              }

              return updated
            } catch (e) {
              const message = getErrors(e)
              fails = {
                data: averbacao.data_averbacao,
                error: "Não foi possível realizar a assinatura digital, verifique o seu certificado digital e tente novamente " + message.message,
                id: averbacao.documento_id
              }
              return fails
            }
          }
        } catch (e) {
          const error = getErrors(e)
          fails = {
            data: averbacao.data_averbacao,
            message: "Erro ao gravar a alteração " + error.message,
            id: averbacao.documento_id
          }
          return fails
        } finally {
          NProgress.done()
          loader({ text: '', active: false })
        }
      },
    }
  }
</script>

<style lang="scss">
  .AverbacaoEProcedimento {
    &_modal {
      &_header {
        background: #074f7f;
        color: #fff;
        padding: 10px;
        font-size: 20px;
        font-weight: bold;
        border-radius: 0px;
      }

      &_header .close {
        color: #fff;
        opacity: 1;
      }

      &_header .close:hover {
        color: #fff;
        opacity: 1 !important;
      }

      &_content {
        border-radius: 0px;
      }

      &_body {
        padding: 20px;
      }

      &_body label {
        font-size: 16px;
        font-weight: 500;
        color: #373a3c;
      }

      &_subtitle {
        border-bottom: 1px solid black ;
        margin: 10px 0px;
      }

      &_subtitle h1 {
        font-size: 18px;
        font-weight: 500;
        color: #262626;
      }
  }

    .averbacoes-buttons {
      display: flex;
      justify-content: flex-end;
      padding: 0.5rem 0.5rem 0.5rem 0;
    }
  }

  .btn-gray {
    color: #fff !important;
    background: #6c757d;
    border-color: #6c757d;
  }

  .btn-gray:active {
    background-color: #545b62 !important;
    border-color: #4e555b !important;
  }

  .btn-gray:hover {
    background-color: #5a6268;
    border-color: #545b62;
  }

  .btn-gray:focus {
    background-color: #5a6268;
    border-color: #545b62;
  }
</style>
